<div class="service_dialog_body">
  <div class="row" style="align-items: center;flex-wrap: nowrap">
    <img [src]="data.icon" alt="{{data.title}}">
    <p class="serviceTitle">{{ data.title | translate}}</p>
  </div>
  <p class="serviceDescription">{{data.description  | translate}}</p>
</div>

